import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';

import Heading from '@bibliocommons/heading';

import MetadataDisplay from 'app/components/bibs/shared/MetadataDisplay';
import { fieldShape } from 'app/shapes/bibPage';
import './Notes.scss';

export default function Notes({ fields, trackFieldItemClick }) {
  if (!fields?.size) {
    return null;
  }

  return (
    <div className="cp-notes">
      <Heading tagName="h3" size="medium" variant>
        <FormattedMessage id="bib_metadata_category_notes" />
      </Heading>
      <MetadataDisplay
        fields={fields}
        handleClick={(fieldItem, fieldValue) => trackFieldItemClick(fieldItem, fieldValue)}
      />
    </div>
  );
}

Notes.propTypes = {
  fields: ImmutablePropTypes.listOf(fieldShape).isRequired,
  trackFieldItemClick: PropTypes.func.isRequired
};
